import HostedDesktopLayout from '../../../layouts/DesktopLayout';
import HostedAppPairingScreen from '../shared/AppPairingScreen';
import { type AppPairingPageProps } from '../../../chulak/ChulakSession';

export default function HostedDesktopAppPairingPage(
  props: AppPairingPageProps,
) {
  return (
    <HostedDesktopLayout>
      <HostedAppPairingScreen {...props} />
    </HostedDesktopLayout>
  );
}
